export enum AmpEventSourceTypeAdmin {
  ADMIN = 'Admin_Portal'
}
